import '../../styles/auth.css';
import { login } from '../../auth';
import { bootShell, showError, clearMessages, describeError } from './_shell';

bootShell();

/** Carry the `?next=` param through to the post-login redirect. */
function getNextParam(): string {
  const params = new URLSearchParams(location.search);
  const raw = params.get('next');
  if (!raw) return '/';
  // Only allow same-origin paths. No protocol-relative or absolute URLs.
  if (raw.startsWith('/') && !raw.startsWith('//')) return raw;
  return '/';
}

// Preserve next= on the "Create account" link too, so a registered user
// lands back where they were originally heading.
const next = getNextParam();
const registerLink = document.getElementById('register-link') as HTMLAnchorElement | null;
if (registerLink && next !== '/') {
  registerLink.href = `/register.html?next=${encodeURIComponent(next)}`;
}

const form = document.getElementById('login-form') as HTMLFormElement;
const emailInput = document.getElementById('email') as HTMLInputElement;
const passwordInput = document.getElementById('password') as HTMLInputElement;
const submitBtn = document.getElementById('submit-btn') as HTMLButtonElement;

form.addEventListener('submit', async (ev) => {
  ev.preventDefault();
  clearMessages();

  const email = emailInput.value.trim();
  const password = passwordInput.value;

  if (!email || !password) {
    showError('Enter your email and password.');
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError('That email does not look right.');
    return;
  }

  submitBtn.disabled = true;
  try {
    await login({ email, password });
    // Hard redirect so the new session cookie is picked up by every module.
    location.href = next;
  } catch (err: any) {
    showError(describeError(err, 'Sign in failed.'));
    submitBtn.disabled = false;
  }
});
